"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { ArrowRight } from "lucide-react";
export default function Hero() {
  const {
    ref: contentRef,
    isVisible: contentVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section id="hero" className="dark bg-background text-foreground relative overflow-hidden">
      <div className="container mx-auto px-4 py-24 lg:py-32">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {}
          <div ref={contentRef} className={`space-y-8 transition-all duration-150 ease-out ${contentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-display font-bold leading-tight tracking-tight text-foreground-dark">
              Administrative Support for ABA & Behavioral Health Providers
            </h1>

            <p className="text-lg md:text-xl text-muted-foreground max-w-xl">
              Professional billing assistance, credentialing support, and
              practice operations—so you can focus on what matters most: your
              clients.
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <Link to="/GetStartedPage">
                <Button size="lg" className="w-full sm:w-auto group transition-all duration-[80ms] hover:-translate-y-0.5 hover:brightness-95 hover:shadow-medium">
                  Request a Consultation
                  <ArrowRight className="transition-transform group-hover:translate-x-1" />
                </Button>
              </Link>

              <Link to="#contact">
                <Button variant="outline" size="lg" className="w-full sm:w-auto transition-all duration-[80ms] hover:-translate-y-0.5 hover:shadow-medium border-border-strong">
                  Contact Us
                </Button>
              </Link>
            </div>
          </div>

          {}
          <div className="relative h-[400px] lg:h-[600px]">
            <div className="absolute inset-0 transition-transform duration-500 ease-out" style={{
            transform: `translateY(${typeof window !== "undefined" ? window.scrollY * 0.1 : 0}px)`
          }}>
              {}
              <div className="absolute inset-0 z-10">
                <svg className="w-full h-full" viewBox="0 0 400 600" preserveAspectRatio="xMidYMid slice">
                  <defs>
                    <clipPath id="geometric-mask">
                      <polygon points="0,0 400,0 400,550 350,600 0,600" />
                    </clipPath>
                  </defs>
                </svg>
              </div>

              {}
              <div className="w-full h-full bg-cover bg-center relative" style={{
              clipPath: "polygon(0 0, 100% 0, 100% 92%, 88% 100%, 0 100%)",
              filter: "blur(0.5px)"
            }}>
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1541656/img/modern_office_professional_workspace.png" alt="Modern professional office environment" className="w-full h-full object-cover" />

                {}
                <div className="absolute inset-0 bg-gradient-to-br from-primary/10 to-transparent" />
              </div>
            </div>

            {}
            <div className="absolute -bottom-4 -right-4 w-32 h-32 bg-primary/20 rounded-full blur-3xl" />
            <div className="absolute top-8 -left-4 w-24 h-24 bg-secondary/20 rounded-full blur-2xl" />
          </div>
        </div>
      </div>

      {}
      <ParallaxEffect />
    </section>;
}
function ParallaxEffect() {
  if (typeof window === "undefined") return null;
  const handleScroll = () => {
    const parallaxElements = document.querySelectorAll("[data-parallax]") as NodeListOf<HTMLElement>;
    parallaxElements.forEach(el => {
      const speed = 0.1;
      const yPos = window.scrollY * speed;
      el.style.transform = `translateY(${yPos}px)`;
    });
  };
  if (typeof window !== "undefined") {
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
  }
  return null;
}